<section class="flex flex-row footer2" >
    <span class="footer-logo2">
      <img [src]="sharedDataService.assetsCdn('images/Fill 1.svg')" alt="Welcome Logo" loading="lazy">
    </span>
    <span class="footer-text2" (click)="showFooterDesc()">
      Your security is our priority.
    </span>
  
  </section>

<web-prequal-security
  *ngIf="showFooterSecurity"
  (closeFooterSecurity)="closeFooterSecurity()"
>
</web-prequal-security>